import React from 'react';
import styles from './Layout.module.scss';

interface ILayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: ILayoutProps) {
  return <main className={styles.contentPage}>{children}</main>;
}
